// Datos de pago y constantes del flujo de compra de retratos.

export const TARJETA = {
  banco: 'BBVA',
  numero: '4152 3138 2196 5287',
  titular: 'Rodolfo Muñoz de la Rocha',
};

// Países a los que por ahora hacemos envíos.
export const PAISES_ENVIO = ['México', 'Estados Unidos', 'Canadá'];

// Token que la IA inserta en su respuesta para que el chat muestre la tarjeta
// de pago bonita en lugar de escribir el número como texto.
export const TOKEN_TARJETA = '[[TARJETA]]';
